module.exports = __webpack_public_path__ + "static/device03-c721cbff35c2d11bad593c71c4e3625d.jpg";